const initialState = {
  loading: false
};

export function fetchMediaMessages(state = initialState, action) {
  switch(action.type) {
    case 'FETCH.COMMUNICATION_MESSAGES.SUCCESS':
    case 'SAVE.COMMUNICATION_MESSAGES.SUCCESS':
      return {
        ...state,
        body: action.response.body,
      };
    default:
      return state
  }
}

export function fetchMediaBackground(state = initialState, action) {
  switch(action.type) {
    case 'FETCH.COMMUNICATION_BACKGROUND.SUCCESS':
    case 'SAVE.COMMUNICATION_BACKGROUND.SUCCESS':
      return {
        ...state,
        body: action.response.body,
      };
    case 'SAVE.COMMUNICATION_BACKGROUND_FILE.SUCCESS':
      var {device} = action.metadata;
      return {
        ...state,
        body: {...state.body, media:{...state.body.media, [device]:action.fileDescription.body}}
      };
    case 'DELETE.COMMUNICATION_BACKGROUND_FILE.SUCCESS':
      var {device} = action.metadata;
      return {
        ...state,
        body: {...state.body, media:{...state.body.media, [device]:undefined}}
      };
    default:
      return state
  }
}

export function fetchMediaBanners(state = initialState, action) {
  switch(action.type) {
    case 'FETCH.COMMUNICATION_BANNERS.SUCCESS':
    case 'SAVE.COMMUNICATION_BANNERS.SUCCESS':
      return {
        ...state,
        body: action.response.body,
      };
    case 'SAVE.BANNER_CONFIGURATION_FILE.SUCCESS':
      var {type, lg, device} = action.metadata;
      var {body:banners={}} = state;
      banners[type] = {...banners[type] || {}, medias:{...(banners[type] || {}).medias}};
      banners[type].medias[lg] = {...banners[type].medias[lg]||{}, [device]: action.fileDescription.body};
      return {
        ...state,
        body: {...state.body, ...banners}
      };
    case 'DELETE.BANNER_CONFIGURATION_FILE.SUCCESS':
      var {type, lg, device} = action.metadata;
      var {body:banners={}} = state;
      banners[type] = {...banners[type] || {}, medias:{...(banners[type] || {}).medias}};
      banners[type].medias[lg] = {...banners[type].medias[lg]||{}, [device]: undefined};
      return {
        ...state,
        body: {...state.body, ...banners}
      };
    default:
      return state
  }
}

function updateBackgroundFile(media, key, fileDescription) {
  const [,, deviceType] = key.split('/');
  return {
    ...media,
    [deviceType]: fileDescription
  }
}

function updateBannerFile(data = {}, key, fileDescription) {
  const [,, brand, deviceType, lang] = key.split('/');
  data[brand] = data[brand] || {};
  data[brand].medias = data[brand].medias || {};
  data[brand].medias[lang] = data[brand].medias[lang] || {};
  data[brand].medias[lang][deviceType] = fileDescription;
  return data;
}



// WEBPACK FOOTER //
// ./src/reducers/medias.js